import React, {useEffect, useState, memo} from 'react';
import {CounterManager} from "../../CounterManager/CounterManager";

import {machine as m} from "../../../constants/machine.constants";

import {LineSpinner} from "../../../index";
import {useMainStateMachine} from "../../MainStateMachineProvider";
import {useSelector} from "@xstate/react";
// import {useRenderCount} from "../../../../../shared/hooks";

const VoiceText = memo(({cardIndex, scenarioIndex}) => {

    const {actor, send} = useMainStateMachine()
    // const renderCount = useRenderCount();

    // 1. Сначала определяем активность
    const isActive = useSelector(actor, (s) =>
        cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex
    );

    // 2. Все остальные данные берем только если активны
    const leftRepeats = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active ? s.context.leftRepeats : 0;
    });

    const isTextSynthesisPending = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active ? s.context.isTextSynthesisPending : false;
    });

    const soundRepeats = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active ? s.context.currentItem?.props?.repeats : 1;
    });

    const isPlayingScenario = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active && s.matches(m.state.playingScenario);
    });
    const isRefresh = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active && s.matches(m.state.refresh);
    });
    const isSound = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active && s.matches(m.state.sound);
    });
    const isTextSynthesis = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active && s.matches(m.state.textSynthesis);
    });

    // console.log(`VoiceText [ID:${cardIndex} SIdx:${scenarioIndex}] render:#${renderCount}`, {leftRepeats, isActive})
    const [isCounterActive, setIsCounterActive] = useState(false);

    useEffect(() => {
        if (isActive && isPlayingScenario) {
            send({type: m.events.SOUND})
        }
    }, [isActive, isPlayingScenario, send]); // Now reacts only to relevant changes

    useEffect(() => {
        if (!isActive) return;

        if (isRefresh) {
            send({type: m.events.REFRESH})
        }
        if (isPlayingScenario || isSound) {
            send({type: m.events.NEXT_REPEAT});
        }
        if (isTextSynthesis) {
            setIsCounterActive(false)
        }

    }, [isActive, isRefresh, isPlayingScenario, isSound, isTextSynthesis, send]);

    const counterSettings = {
        local: {name: "repeats", value: soundRepeats},
        global: {name: "leftRepeats", value: leftRepeats}
    }

    const changeCount = (type) => {
        const guard = true; // Always Local in player
        const payload = counterSettings.local;
        if (type === "inc") {
            send({type: m.events.INCREMENT, data: {payload, guard}})
        } else {
            send({type: m.events.DECREMENT, data: {payload, guard}})
        }
    }

    const onAction = () => {
        if (isCounterActive) {
            send({type: m.events.REFRESH})

        } else {
            send({type: m.events.PAUSE})
        }
        setIsCounterActive(prev => !prev)
    }

    return (
        <>
            {isActive && <LineSpinner isAction={isTextSynthesisPending} delayAction={1000}/>}
            <CounterManager
                isVisible={isActive}
                count={isCounterActive ? counterSettings.local.value : counterSettings.global.value}
                onIncrement={() => changeCount('inc')}
                onDecrement={() => changeCount('dec')}
                isActive={isCounterActive}
                onAction={onAction}
            />
        </>
    );
});

const voiceTextProps = ["cardIndex", "scenarioIndex"]


export {VoiceText, voiceTextProps};